var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "article",
    {
      staticClass: "box-section chat-section",
      staticStyle: { "max-width": "100%" }
    },
    [
      _c(
        "div",
        {
          staticClass: "message-section is-clearfix clear-margin-bottom",
          class: _vm.cls
        },
        [_c("p", [_vm._v(_vm._s(_vm.title) + " ")])]
      ),
      _c("div", { staticClass: "out-page" }, [
        _c("div", { ref: "messages", staticClass: "page" }, [
          _c(
            "div",
            { staticClass: "messages" },
            [
              _c("chat", {
                attrs: { messages: _vm.messages, persons: _vm.persons }
              })
            ],
            1
          )
        ]),
        _c("div", { staticClass: "box-chat" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.message,
                expression: "message"
              }
            ],
            staticClass: "inputMessage",
            attrs: { type: "text", placeholder: "Type here..." },
            domProps: { value: _vm.message },
            on: {
              keyup: function($event) {
                if (
                  !("button" in $event) &&
                  _vm._k($event.keyCode, "enter", 13, $event.key)
                ) {
                  return null
                }
                _vm.sendMessage()
              },
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.message = $event.target.value
              }
            }
          }),
          _c(
            "button",
            { attrs: { type: "button" }, on: { click: _vm.toggleUpload } },
            [_c("i", { staticClass: "fa fa-paperclip" })]
          )
        ]),
        _c(
          "div",
          { style: _vm.style },
          [
            _c("br"),
            _c("upload", { ref: "upload" }),
            _c("br"),
            _c("isButton", {
              ref: "btnCreate",
              attrs: {
                slot: "action",
                showProgress: true,
                progressLevel: _vm.progressLevel,
                onClick: _vm.sendFile,
                title: "Upload"
              },
              slot: "action"
            })
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4cdd6637", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4cdd6637","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/chat-full-box.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-4cdd6637","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/chat-full-box.vue
// module chunks = 0 1 2 3 4